import type NumberUnit from '@exodus/currency';
import { formatAssetAmount } from '@exodus/formatting/lib/asset';
import Skeleton from '@passkeys/ui/skeleton';
import Text from '@passkeys/ui/text';

import { cn } from '@/ui/utils/classnames';
import { formatFiat } from '@/ui/utils/formatting';

export interface AmountProps {
  cryptoAmount?: NumberUnit;
  fiatAmount?: NumberUnit | null;
  unit?: string;
  className?: string;
  received?: boolean;
}

function Amount({
  cryptoAmount,
  fiatAmount,
  unit,
  className,
  received = false,
}: AmountProps) {
  return (
    <div className={cn('relative flex flex-col items-end', className)}>
      {cryptoAmount && unit ? (
        <Text
          size={14}
          className={cn(received && 'text-green-500')}
          dataTestId="crypto-amount"
        >
          {received && '+'}
          {formatAssetAmount(cryptoAmount.toDefaultNumber(), {
            useGrouping: true,
            maxSignificant: 6,
          })}{' '}
          {unit}
        </Text>
      ) : (
        <Skeleton width={64} height={14} className="my-[3px]" />
      )}

      {fiatAmount ? (
        <Text
          size={11}
          monospace
          className="absolute bottom-0 translate-y-full leading-none text-gray-400 theme-dark:text-neutral-200"
          dataTestId="fiat-amount"
        >
          {formatFiat(fiatAmount)}
        </Text>
      ) : (
        <Skeleton
          width={32}
          height={11}
          className="absolute bottom-0 translate-y-full"
        />
      )}
    </div>
  );
}

export default Amount;
